"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseQuery_1 = require("./BaseQuery");

var Query_1 = require("./Query");

var SingleDocumentQuery =
/** @class */
function (_super) {
  __extends(SingleDocumentQuery, _super);

  function SingleDocumentQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SingleDocumentQuery.prototype.initialize = function (executionOptions) {
    this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
  };

  SingleDocumentQuery.prototype.getOptions = function () {
    var _a = this.queryOptions,
        key = _a.key,
        keyQuery = _a.keyQuery,
        childKey = _a.childKey,
        _b = _a.options,
        options = _b === void 0 ? {} : _b;
    return __assign({
      key: key,
      keyQuery: keyQuery,
      childKey: childKey
    }, options.fundManager || {});
  };

  SingleDocumentQuery.prototype.getRawValue = function (executionOptions) {
    var _a = this.options,
        key = _a.key,
        childKey = _a.childKey;
    var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
    var document;

    if (context) {
      document = context.document;
    }

    if (document) {
      if (key) {
        var meta = document.meta,
            inferred = document.inferred;

        if (key === 'meta' && meta) {
          return childKey && meta[childKey] && meta[childKey].value;
        }

        if (key === 'inferred' && inferred) {
          return childKey && inferred[childKey] && inferred[childKey].value;
        }

        return document[key];
      }

      return document;
    }

    return;
  };

  return SingleDocumentQuery;
}(BaseQuery_1.BaseQuery);

exports.SingleDocumentQuery = SingleDocumentQuery;